import { forwardRef, type Ref, type SVGProps } from "react";
const IconGiftFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M4 27a3 3 0 0 0 3 3h8V19H4zm13 3h8a3 3 0 0 0 3-3v-8H17zM29 8h-4.56A3.9 3.9 0 0 0 25 6a4 4 0 0 0-7-2.66 17 17 0 0 0-2 2.79 17 17 0 0 0-2-2.79A4 4 0 0 0 7 6a3.9 3.9 0 0 0 .56 2H3a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h12V8h2v9h12a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1M11 8a2 2 0 1 1 1.49-3.34A13.2 13.2 0 0 1 14.71 8zm8.51-3.34A2 2 0 1 1 21 8h-3.71a13.2 13.2 0 0 1 2.22-3.34" />
  </svg>
);
const ForwardRef = forwardRef(IconGiftFilledSVG);
ForwardRef.displayName = "IconGiftFilled";
export { ForwardRef as IconGiftFilled };
